import { BagClient } from "@lululemon/ecom-bag-sdk";
import { getCookie } from "@lululemon/ecom-site-utils";
import { graphqlClient } from "./graphql-client";
import LocaleManager from "@lululemon/ecom-site-utils/src/utils/locale-manager";

const getLocale = () => {
  const { nextLocale, defaultLocale } = LocaleManager.locale;
  const locale = nextLocale || defaultLocale;

  // Extract country code from locale
  const countryCode = locale ? locale.split("-")[1]?.toUpperCase() : "US";

  return {
    countryCode
  };
};

let bagClient = null;
const getBagClient = ({ locale = getLocale() } = {}) => {
  if (!bagClient) {
    bagClient = new BagClient({ client: graphqlClient, locale });
  }
  return bagClient;
};
export { getBagClient };
